// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1vtYC","search":"Settings_search__2-pOk","filter":"Settings_filter__1Q04n"};